import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LanguageService } from '../../../../core/services/language.service';

@Component({
  selector: 'app-language-selector',
  imports: [CommonModule, FormsModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent implements OnInit {

  private languageService = inject(LanguageService);

  languages = [
    { code: 'en', label: 'EN' },
    { code: 'hu', label: 'HU' },
  ];
  
  selectedLanguage: string = 'en';

  ngOnInit(): void {
      const storedLanguage = this.languageService.getLanguage();
      this.selectedLanguage = storedLanguage || 'en';
  }

  changeLanguage(language: string) {
    this.selectedLanguage = language;
    this.languageService.setLanguage(language);
  }

}
